import type { ModalityType } from '../types';

export const procedureColors: { [x in ModalityType]: string } = {
  Lap: 'bg-lap',
  Robotic: 'bg-robotic',
  Open: 'bg-open',
  Other: 'bg-other',
};
